/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoNicknameChangeLogListNicknameChangeLogData model module.
 * @module model/LogControllerDtoNicknameChangeLogListNicknameChangeLogData
 * @version 1.0
 */
class LogControllerDtoNicknameChangeLogListNicknameChangeLogData {
    /**
     * Constructs a new <code>LogControllerDtoNicknameChangeLogListNicknameChangeLogData</code>.
     * @alias module:model/LogControllerDtoNicknameChangeLogListNicknameChangeLogData
     */
    constructor() { 
        
        LogControllerDtoNicknameChangeLogListNicknameChangeLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoNicknameChangeLogListNicknameChangeLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoNicknameChangeLogListNicknameChangeLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoNicknameChangeLogListNicknameChangeLogData} The populated <code>LogControllerDtoNicknameChangeLogListNicknameChangeLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoNicknameChangeLogListNicknameChangeLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nickname')) {
                obj['nickname'] = ApiClient.convertToType(data['nickname'], 'String');
            }
            if (data.hasOwnProperty('beforeNickname')) {
                obj['beforeNickname'] = ApiClient.convertToType(data['beforeNickname'], 'String');
            }
            if (data.hasOwnProperty('afterNickname')) {
                obj['afterNickname'] = ApiClient.convertToType(data['afterNickname'], 'String');
            }
            if (data.hasOwnProperty('cost')) {
                obj['cost'] = ApiClient.convertToType(data['cost'], 'Number');
            }
            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
            if (data.hasOwnProperty('managerEmail')) {
                obj['managerEmail'] = ApiClient.convertToType(data['managerEmail'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoNicknameChangeLogListNicknameChangeLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoNicknameChangeLogListNicknameChangeLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['nickname'] && !(typeof data['nickname'] === 'string' || data['nickname'] instanceof String)) {
            throw new Error("Expected the field `nickname` to be a primitive type in the JSON string but got " + data['nickname']);
        }
        // ensure the json data is a string
        if (data['beforeNickname'] && !(typeof data['beforeNickname'] === 'string' || data['beforeNickname'] instanceof String)) {
            throw new Error("Expected the field `beforeNickname` to be a primitive type in the JSON string but got " + data['beforeNickname']);
        }
        // ensure the json data is a string
        if (data['afterNickname'] && !(typeof data['afterNickname'] === 'string' || data['afterNickname'] instanceof String)) {
            throw new Error("Expected the field `afterNickname` to be a primitive type in the JSON string but got " + data['afterNickname']);
        }
        // ensure the json data is a string
        if (data['managerEmail'] && !(typeof data['managerEmail'] === 'string' || data['managerEmail'] instanceof String)) {
            throw new Error("Expected the field `managerEmail` to be a primitive type in the JSON string but got " + data['managerEmail']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} transactionNo
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['email'] = undefined;

/**
 * @member {String} nickname
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['nickname'] = undefined;

/**
 * @member {String} beforeNickname
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['beforeNickname'] = undefined;

/**
 * @member {String} afterNickname
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['afterNickname'] = undefined;

/**
 * @member {Number} cost
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['cost'] = undefined;

/**
 * @member {Number} managerNo
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['managerNo'] = undefined;

/**
 * @member {String} managerEmail
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['managerEmail'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoNicknameChangeLogListNicknameChangeLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoNicknameChangeLogListNicknameChangeLogData;

